import {Injectable} from "@angular/core";
import {RequestConfig, RestResponse} from "../shared/rest/rest.request";
import {Observable} from "rxjs";
import {RequestMethod} from "@angular/http";
import {CustomHttp} from "../common/http/custom.http";
import {PageImpl} from "../common/http/PageImpl";
import { NzI18nService ,es_ES} from "ng-zorro-antd";


@Injectable()
export class CustomerService {
    private CREATE_CODE = new RequestConfig("CUS", "application/json", true, RequestMethod.Post, "/customers");
    private EDIT_CODE = new RequestConfig("CUS", "application/json", true, RequestMethod.Put, "/customers/{customerId}");
    private DELETE_CODE = new RequestConfig("CUS", "application/json", true, RequestMethod.Delete, "/customers/{customerId}");
    private GET_CODE = new RequestConfig("CUS", "application/json", true, RequestMethod.Get, "/customers/{customerId}");
    private GET_PAGE = new RequestConfig("CUS", "application/json", true, RequestMethod.Get, "/customers");
    private GET_PAGE_BY_GROUPS = new RequestConfig("CUS", "application/json", true, RequestMethod.Post, "/customers/findAll");

    public customerDataProperties: Array<any> = [
        {
            key: "idCustomer",
            legend: "Id de Cliente"
        },
        {
            key: "createdDate",
            legend: "Fecha de Creación"
        },
        {
            key: "customerType",
            legend: "Tipo de cliente"
        },
        {
            key: "name",
            legend: "Nombre"
        },
        {
            key: "paternalName",
            legend: "Apellido Paterno"
        },
        {
            key: "maternalName",
            legend: "Apellido Materno"
        },
        {
            key: "rfc",
            legend: "RFC"
        },
        {
            key: "commercialName",
            legend: "Nombre Comercial"
        },
        {
            key: "customerStatus",
            legend: "Estatus"
        },
        {
            key: "street",
            legend: "Calle"
        },
        {
            key: "street",
            legend: "Calle"
        },
        {
            key: "numExt",
            legend: "# Ext."
        },
        {
            key: "numInt",
            legend: "# Int."
        },
        {
            key: "zipCode",
            legend: "Código Postal"
        },
        {
            key: "country",
            legend: "País"
        },
        {
            key: "city",
            legend: "Ciudad"
        },
        {
            key: "suburb",
            legend: "Colonia"
        },
        {
            key: "street1",
            legend: "Calle 1"
        },
        {
            key: "street2",
            legend: "Calle 2"
        }
    ];

    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar cliente
     */
    saveCustomer(customer: Customer): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, customer)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un cliente
     */
    getCustomer(idCustomer: number): Observable<Customer> {
        return this.http.sendRequest(this.GET_CODE, {}, idCustomer)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de cliente
     */
    updateCustomer(customer: Customer): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, customer, customer.idCustomer)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de cliente
     */
    deleteCustomer(idCustomer: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idCustomer)
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<Customer>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getPageByGroups(request: CustomerRequest): Observable<PageImpl<Customer>> {
        return this.http.sendRequest(this.GET_PAGE_BY_GROUPS, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    searchCustomerByGroups(request: CustomerRequest): Observable<Array<Customer>> {
        return this.http.sendRequest(this.GET_PAGE_BY_GROUPS, request)
            .map(res => res.json().content)
            .catch(error => this.http.handleError(error));
    }

    getProperty(key: string): any {
        return this.customerDataProperties.find(obj => obj.key == key);
    }
}


/**
 * Clase para manejar la información de los clientes
 */
@Injectable()
export class Customer {
    public idCustomer: number;
    public createdDate: Date;
    public lastModifiedDate: Date;
    public customerType: string;
    public name: string;
    public paternalName: string;
    public maternalName: string;
    fullName: string;
    public rfc: string;
    public commercialName: string;
    public customerStatus: string;
    public email: string;
    public addressList: Array<Address>;
    public address: Array<Address>;
    public numberList: Array<ContactNumbers>;
    public numbers: Array<ContactNumbers>;
    public infoList: Array<AdditionalInfo>;
    public additionalInfos: Array<AdditionalInfo> = [];
    public ticketType: number;

    constructor() {
        this.addressList = [];
        this.numberList = [];
        this.infoList = [];
        this.additionalInfos = [];
    }

    /**
     * Agrega una nueva dirección al cliente
     * @param address
     */
    addAddress(address: Address) {
        this.addressList.push(address);
    }

    /**
     * Eliminar una dirección utilizando el indice de dicha dirección
     * @param index
     */
    removeAddressByIndex(index: number) {
        this.addressList.slice(index, 1);
    }

    /**
     * Eliminar una dirección utilizando el ID del mismo
     * @param addressId
     */
    removeAddressById(addressId: number) {
        let index: number = this.addressList.findIndex(x => x.idCustomerAddress != undefined && x.idCustomerAddress == addressId);
        if (index != -1)
            this.removeAddressByIndex(index);
    }

    /**
     * Agregar un numero de contacto al cliente
     * @param contactNumber
     */
    addNumber(contactNumber: ContactNumbers) {
        this.numberList.push(contactNumber);
    }

    /**
     * Eliminar el numero del cliente utilizando el indice del array
     * @param index
     */
    removeNumberByIndex(index: number) {
        this.numberList.splice(index, 1);
    }

    /**
     * Eliminar el número del cliente utilizando el ID del mismo
     * @param numberId
     */
    removeNumberById(numberId: number) {
        let index: number = this.numberList.findIndex(x => x.idCustomerContactNumber != undefined && x.idCustomerContactNumber == numberId);
        if (index != -1)
            this.removeNumberByIndex(index);
    }

    /**
     * Agregar información adicional al cliente
     * @param {AdditionalInfo} additionalInfo
     */
    addAdditionalInfo(additionalInfo: AdditionalInfo) {
        this.infoList.push(additionalInfo);
    }

    /**
     * Eliminar la información adicional del cliente utilizando el indice del array
     * @param index
     */
    removeAdditionalInfoByIndex(index: number) {
        this.infoList.splice(index, 1);
    }

    /**
     * Eliminar información adicional utilizando el ID
     * @param additionalInfoId
     */
    removeAdditionalInfoById(additionalInfoId: number) {
        let index: number = this.infoList.findIndex(x => x.idCustomerAddionalInfo != undefined && x.idCustomerAddionalInfo == additionalInfoId);
        if (index != -1)
            this.removeAdditionalInfoByIndex(index);
    }
}

/**
 * Clase para manejar la informacion adicional del cliente
 */
@Injectable()
export class AdditionalInfo {
    public idCustomerAddionalInfo: number;
    public key: string;
    public value: string;
    public additionalInfoStatus: string;
}

/**
 * clase para manejar los numeros de contacto del cliente
 */
@Injectable()
export class ContactNumbers {
    public idCustomerContactNumber: number;
    public phone: string;
    public phoneType: string;
    public contactNumberStatus: string;
}

/**
 * Clase para manejar las direcciones del cliente
 */
@Injectable()
export class Address {
    public idCustomerAddress: number;
    public street: string;
    public numExt: string;
    public numInt: string;
    public zipCode: number;
    public country: string;
    public state: string;
    public city: string;
    public suburb: string;
    public street1: string;
    public street2: string;
    public addressStatus: string;
    public latitude: number;
    public longitude: number;
    public manzana?: number;
    public lote?: number;
}

/**
 * Clase para manejar las variables por las cuales obtener el cliente paginable
 */
@Injectable()
export class CustomerRequest {
    public email: string;
    public name: string;
    public page: number;
    public size: number;
    public orderColumn: string;
    public orderType: string;
}

@Injectable()
export class addAddress {
    public calle: string;
    public numExt: any;
    public numInt: any;
    public codigoPostal: string;
    public colonia: string;
    public municipio: string;
    public estado: string;
    public latitud: number;
    public longitud: number;
    public entreCalle1: string;
    public entreCalle2: string;
    public country: string;
}

export class CustomerAdvanceSearch {
    active: boolean;
    name: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
}

